import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const dynamoDBOption: Option<CriteriaKey> = {
  name: 'Amazon DynamoDB',
  description:
    'Amazon DynamoDB is a fully managed, serverless, key-value NoSQL database designed to run high-performance applications at any scale. DynamoDB offers built-in security, continuous backups, automated multi-Region replication, in-memory caching, and data import and export tools.',
  tags: ['NoSQL', 'key-value'],
  pros: [
    'Seamless multi-region data replication',
    'Virtually unlimited scalability',
    'Fully managed (serverless)',
    'Lightning-fast response times',
    'Flexible data model',
  ],
  cons: [
    'High learning curve',
    'Limited querying capabilities',
    'Difficult to predict Costs',
    'Eventual consistency',
    'Item size limitations',
    'Vendor dependency',
  ],
  documentationLink: 'https://aws.amazon.com/dynamodb/',
  criteriaScores: {
    availability: { score: { value: 10 } },
    securityAndCompliance: { score: { value: 8 } },
    performanceAndScalability: { score: { value: 10 } },
    dataConsistency: { score: { value: 7 } },
    dataStructure: { score: { value: 5 } },
    costOptimization: { score: { value: 8 } },
    dataPersistence: { score: { value: 8 } },
  },
};
